import { User } from './user';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UserRegistrationService {
  doProductRegistration(product: import("./product").Product) {
    throw new Error("Method not implemented.");
  }

  constructor(private http:HttpClient) { }

  //Does an API Call using POST Http Method
  //for signup
  public doRegistration(user: User) {
    return this.http.post("http://localhost:8080/create", user, {responseType: 'text' as 'json'});
  }
  //checking data during login
  // public userData(): Observable<any>
  // {
  //  //return this.http.get(`${this.url}`);
  //  return this.http.get("http://localhost:8080/getAll");
  // }
  userData()
  {
   //return this.http.get(`${this.url}`);
   return this.http.get("http://localhost:8080/getAll");
  }
  //other methods from here
  deleteAll() {
    return this.http.get("http://localhost:8080/deleteAll",{ responseType: 'text' as 'json'});
  }
  findbyName(name: String){
    return this.http.get("http://localhost:8080/get?firstName="+name);
  }
  deletebyName(name: String){
    return this.http.get("http://localhost:8080/delete?firstName="+name);
  }
  
  //Calling an API using GET Http Request
  // public doSomething() {
  //   response is an observable
  //   let response = this.http.get("URL");
  //   response.subscribe((some_variable_to_store_response) => console.log(some_variable_to_store_response));
  //    CAPTURE THE DATA STORED IN THE VARIABLE AND DISPLAY IT IN INNER HTML 
  // }

}

